import axios from "axios";
import React, { useContext, useState } from "react";
import { showErrorToast, showSuccessToast } from "../../utils/toaster";
import { FaSpinner } from "react-icons/fa";
import { DataProvider } from "../ContextProvider";
import ForgotPasswordForm from "./ForgotPasswordForm";
import { API_URL } from "../../api";

function LoginForm({ closeLoginDialog }) {
  let { issetLoginDialogOpen, setisSignup, setshowotpcomponent } =
    useContext(DataProvider);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  const handleForgotPasswordClick = () => {
    setIsForgotPasswordOpen(true);
  };

  const handleBackToLoginClick = () => {
    setIsForgotPasswordOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Validate email format
  const isValidEmail = (email) =>
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedEmail = formData.email.trim();
    const trimmedPassword = formData.password.trim();
    // Validate form inputs
    if (!trimmedEmail || !trimmedPassword) {
      showErrorToast("Please fill in all fields.");
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      showErrorToast("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true); // Disable form while submitting

    try {
      // Send login request using axios
      const response = await axios.post(`${API_URL}/api/user/login`, {
        email: trimmedEmail,
        password: trimmedPassword,
      });
      let data = response?.data;

      if (!data?.user?.isVerified) {
        localStorage.setItem("usercredentials", JSON.stringify(data.user));
        showErrorToast("Please verify first");
        issetLoginDialogOpen(true);
        setisSignup(true);
        setshowotpcomponent(true);
        return;
      }

      // Check if login is successful
      if (response.status === 200) {
        const { user, token } = response.data;
        // Save userId and token in localStorage
        localStorage.setItem("userId", user._id);
        localStorage.setItem("token", token);
        localStorage.setItem("usercredentials", JSON.stringify(data.user));
        closeLoginDialog();
        showSuccessToast("Login successful! Welcome to Buildpro.");
      }
    } catch (error) {
      if (error.response) {
        const message = error.response?.data?.message?.toLowerCase();

        if (message?.includes("invalid")) {
          showErrorToast("Incorrect email or password.");
        } else if (message?.includes("user not found")) {
          showErrorToast("No account found with this email.");
        } else {
          // Developer-level message: not shown to user
          // console.error("Backend error:", error.response?.data.message);
          showErrorToast("Login failed. Please try again.");
        }
      } else if (error.request) {
        // console.error("Network error:", error); // Developer use only
        showErrorToast("Unable to connect. Please check your internet connection.");
      } else {
        // console.error("Unexpected error:", error.message); // Developer only
        showErrorToast("Something went wrong. Please try again.");
      }
    }
    finally {
      setIsSubmitting(false); // Re-enable form submission
    }
  };

  return (
    <div>
      {isForgotPasswordOpen ? (
        <ForgotPasswordForm onResetSuccess={handleBackToLoginClick} />
      ) : (
        <form className="flex flex-col" onSubmit={handleSubmit}>
          {/* Email Input */}
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              Email Address
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting} // Disable input while submitting
              className="mt-2 block w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your email"
            />
          </div>

          {/* Password Input */}
          <div className="mt-1">
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              disabled={isSubmitting} // Disable input while submitting
              className="mt-2 block w-full rounded-md border border-gray-300 px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your password"
            />
          </div>
          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r mt-5 from-blue-500 to-indigo-600 text-white font-medium py-2 rounded-md shadow-md hover:from-indigo-600 hover:to-blue-500 transition-transform transform hover:scale-105 flex justify-center items-center"
            disabled={isSubmitting} // Disable button while submitting
          >
            {isSubmitting ? (
              <>
                <FaSpinner className="animate-spin text-2xl text-white mr-2" />
                Signing In...
              </>
            ) : (
              "Sign In"
            )}
          </button>

          {/* Forgot Password Link */}
          <div className="text-center mt-4">
            <button
              type="button"
              onClick={handleForgotPasswordClick}
              className="text-blue-600 hover:underline"
            >
              Forgot Password?
            </button>
          </div>
        </form>
      )}
    </div>
  );
}

export default LoginForm;
